module.exports = __webpack_public_path__ + "img/rifle.m39.e1892df0.png";